import { createContext } from 'react'
import { FieldMetadata } from './fieldMetadata.types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FieldMetadataContext = createContext<Record<string, FieldMetadata<any>>>(
  {}
)

export default FieldMetadataContext
